import PropTypes from 'prop-types';
import React from 'react';
import FooterColHeading from './FooterColHeading';
import FooterLink from './FooterLink';

const FooterLinkList = ({ linksList = [], title = '' }) => {
  return (
    <>
      <div className="footer-link-list-container">
        <FooterColHeading>{title}</FooterColHeading>
        <ul className="footer-link-list">
          {linksList.map((link, index) => {
            if (!link) return;

            return (
              <FooterLink href={link?.href} key={index} text={link?.text} />
            );
          })}
        </ul>
      </div>
      <style jsx>{`
        .footer-link-list {
          display: inline;
          list-style: none;
          margin: 0;
          padding: 0;
        }
      `}</style>
    </>
  );
};

export default FooterLinkList;

FooterLinkList.propTypes = {
  linksList: PropTypes.arrayOf(
    PropTypes.shape({
      href: PropTypes.string,
      text: PropTypes.string,
    }),
  ),
  title: PropTypes.string,
};
